<eid-header-container class="layoutHeader"></eid-header-container>
<div class="layoutContent" #rootPage>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<eid-footer-container class="layoutFooter"></eid-footer-container>
